import React from "react";

export default function CompanyLink({ company, disabled = false }) {
  return disabled ? (
    company.name
  ) : (
    <a onClick={e => e.stopPropagation()} href={"/companies/" + company.id} target="_blank">
      {company.name}
    </a>
  );
}
